/**
 * KTUI - Free & Open-Source Tailwind UI Components by Keenthemes
 * Copyright 2025 by Keenthemes Inc
 */

export { KTStepper } from './stepper';
export type { KTStepperConfigInterface, KTStepperInterface } from './types';
